<template>
  <div class="product-prices-block">
    <div class="product-prices-block__counter-info">
      <div v-if="isShowTextInfo" class="product-prices-block__last-label">
        Последний
      </div>
      <div v-if="showCounter" class="product-prices-block__counter">
        <counter-control
          :max-value="maxCount"
          :values="count"
          size="small"
          @change="handlerChangeCount"
        />
      </div>
      <div v-if="count > 1" class="product-prices-block__counter-total">
        {{ count }} x {{ mainPriceFormatted }}
      </div>
    </div>
    <div v-if="!isGift" class="product-prices-block__prices">
      <div
        class="product-prices-block__price"
        :class="{ '_sale': isSale }"
      >
        {{ discountedOnCountFormatted }}
      </div>
      <div
        v-if="isSale"
        class="product-prices-block__price _old"
      >
        {{ totalOnCountFormatted }}
      </div>
      <div
        v-if="+amount.total > +amount.discounted"
        class="product-prices-block__price _discount"
      >
        Экономия {{ savingMoney }}
      </div>
    </div>
    <div v-else class="product-prices-block__prices">
      <div class="product-prices-block__price">
        0 p.
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, watch, computed } from '@vue/composition-api';
import { Counter } from '@book24/ui-components';

import { priceFormatted } from '@/utils/formatters/formattedPrice';

import useCount from '@/compositions/useCount';

export default defineComponent({
  name: 'PricesBlock',
  components: {
    CounterControl: Counter,
  },
  props: {
    amount: { type: Object, default: () => ({ discounted: 0, total: 0 }) },
    quantityAvailable: { type: Number, default: 1 },
    isGift: { type: Boolean, default: false },
    isAvailable: { type: Boolean, default: true },
    isPreOrder: { type: Boolean, default: false },
    isLast: { type: Boolean, default: false },
    quantityInBasket: { type: Number, default: 1 },
    maxCount: { type: Number, default: 1 },
    isBasket: { type: Boolean, default: true },
    showCounter: { type: Boolean, default: true },
  },
  setup(props) {
    const { count, handlerChangeCount } = useCount(props.quantityInBasket);

    const mainPriceFormatted = computed(() => priceFormatted(props.amount.discounted, { setFreeText: false }));

    const totalOnCountFormatted = computed(() => {
      const price = props.amount.total * count.value;
      return priceFormatted(price, { setFreeText: false });
    });

    const discountedOnCountFormatted = computed(() => {
      const price = props.amount.discounted * count.value;
      return priceFormatted(price, { setFreeText: false });
    });

    const savingMoney = computed(() => {
      const price = (props.amount.total - props.amount.discounted) * count.value;
      return priceFormatted(price, { setFreeText: false });
    });

    const isShowTextInfo = computed(() => props.isLast && !props.isPreOrder);

    const isSale = computed(() => +props.amount.discounted < +props.amount.total);

    watch(
      () => props.quantityInBasket,
      (value, oldValue) => {
        if ((value !== oldValue) && (count.value !== value)) {
          count.value = value;
        }
      },
    );

    watch(
      () => props.maxCount,
      (value) => {
        if (count.value > value) {
          count.value = value;
        }
      },
      { immediate: true },
    );

    return {
      count,
      mainPriceFormatted,
      totalOnCountFormatted,
      discountedOnCountFormatted,
      savingMoney,
      isShowTextInfo,
      isSale,
      handlerChangeCount,
    };
  },
});
</script>

<style lang="less">
.product-prices-block {
  display: flex;
  justify-content: flex-end;

  &__counter-info {
    flex: 0 0 106px;
    margin-right: @size-x10;
  }

  &__last-label {
    .small2();

    text-align: center;
    color: @white;
    border-radius: @main-size;
    background-color: @pink;
    padding: 0 @size-x2;
    display: inline-block;
  }

  &__counter-total {
    .small2();

    text-align: center;
    color: @gray;
    margin-top: @size-x2;
  }

  &__prices {
    flex: 0 0 117px;
    padding-top: @main-size;
  }

  &__price {
    .h4-desktop();

    text-align: right;
    white-space: nowrap;

    &._old {
      .small();

      color: @gray;
      text-decoration: line-through;
      font-weight: normal;
    }

    &._discount {
      .small();

      color: @red-error;
      font-weight: normal;
    }
  }
}
</style>
